import IndustrySelect from './Index.vue'

IndustrySelect.install = function(Vue) {
    Vue.component(IndustrySelect.name, IndustrySelect)
}

export default IndustrySelect
